import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CheckoutPage = loadAsyncComponent(() => import('./Container'), 'page');
